"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SoundController {
    constructor() {
        this.state = RadioState.Mute;
        this.timePassedInState = 0;
        this.radioStateTime = 0;
        this._volumeLevel = 1;
        this.musicArray = new Array();
        this.soundArray = new Array();
    }
    set sound(value) {
        this._sound = value;
    }
    stopAllSounds() {
        for (let soundArrayElement of this.soundArray) {
            soundArrayElement.stop();
        }
    }
    stopAllMusic() {
        for (let musicArrayElement of this.musicArray) {
            musicArrayElement.stop();
        }
    }
    stopAllAudio() {
        this.stopAllMusic();
        this.stopAllSounds();
    }
    playSound(name) {
        let x = this._sound.add(name);
        this.soundArray.push(x);
        this._sound.play(name);
        return x.duration;
    }
    initRadioSong() {
        this.stopAllMusic();
        this.playRadioStatic(250 + this.getRandomInt(1000));
    }
    update(delta) {
        this.setVolume();
        this.timePassedInState += delta;
        if (this.state == RadioState.Static) {
            if (this.timePassedInState >= this.radioStateTime) {
                this.playNextRadioSong(true);
            }
        }
        else if (this.state == RadioState.Playing) {
            if (this.timePassedInState >= this.radioStateTime) {
                this.playNextRadioSong(false);
            }
        }
    }
    playNextRadioSong(intermediate) {
        this.stopAllMusic();
        let x = "radio" + this.getRandomInt(11);
        let y = this.playMusic(x, false, intermediate);
        this.switchState(RadioState.Playing, y * 1000);
    }
    playMusic(musicName, looping, intermediate) {
        this.stopAllMusic();
        let bs = this._sound.add(musicName);
        this.musicArray.push(bs);
        let x = 0;
        if (intermediate) {
            x = this.getRandomInt(bs.duration);
        }
        bs.play({
            mute: false,
            volume: 0.25 * this._volumeLevel,
            rate: 1,
            detune: 0,
            seek: x,
            loop: false,
            delay: 0
        });
        this._currentlyPlaying = bs;
        return bs.duration - x;
    }
    static getInstance() {
        if (SoundController.sc == null) {
            SoundController.sc = new SoundController();
        }
        return SoundController.sc;
    }
    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }
    playRadioStatic(randomInt) {
        this.playMusic("radio_static", true, true);
        this.switchState(RadioState.Static, randomInt);
    }
    switchState(state, time) {
        this.timePassedInState = 0;
        this.radioStateTime = time;
        this.state = state;
    }
    setVolume() {
        for (let musicArrayElement of this.musicArray) {
            // @ts-ignore
            musicArrayElement.setVolume(this._volumeLevel * 0.25);
        }
    }
    adjustVolume() {
        switch (this._volumeLevel) {
            case 0:
                this._volumeLevel++;
                break;
            case 1:
                this._volumeLevel++;
                break;
            case 2:
                this._volumeLevel++;
                break;
            case 3:
                this._volumeLevel++;
                break;
            case 4:
                this._volumeLevel = 0;
                break;
            default:
                console.log("Fuck, this should not be reachable");
                break;
        }
        this.setVolume();
    }
}
exports.SoundController = SoundController;
var RadioState;
(function (RadioState) {
    RadioState[RadioState["Playing"] = 1] = "Playing";
    RadioState[RadioState["Static"] = 2] = "Static";
    RadioState[RadioState["Mute"] = 3] = "Mute";
})(RadioState || (RadioState = {}));
